<template>
  <v-dialog
    v-model="localIsOpen"
    max-width="340px"
    transition="dialog-transition"
    content-class="sensitive-content-dialog-container"
    overlay-color="#0f172a"
    :overlay-opacity="0.65"
  >
    <div class="sensitive-content-card">
      <div class="sensitive-content-icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="21" stroke="#2c3e50" stroke-width="3.5" />
          <path d="M24 14V26" stroke="#2c3e50" stroke-width="3.5" stroke-linecap="round" />
          <circle cx="24" cy="34" r="2.2" fill="#2c3e50" />
        </svg>
      </div>

      <h3 class="sensitive-content-title">
        {{ title || $t('harmony.contentExplicit') }}
      </h3>

      <p class="sensitive-content-desc">
        {{ description || $t('harmony.content+18') }}
      </p>

      <div class="sensitive-content-actions">
        <button
          type="button"
          class="sensitive-btn sensitive-btn-confirm"
          @click="handleConfirm"
        >
          {{ confirmText || $t('harmony.showContentExplicit') }}
        </button>

        <button
          type="button"
          class="sensitive-btn sensitive-btn-cancel"
          @click="handleCancel"
        >
          {{ cancelText || $t('harmony.hideContentExplicit') }}
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'SensitiveContentModal',

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      localIsOpen: this.isOpen
    };
  },

  watch: {
    isOpen(newVal) {
      this.localIsOpen = newVal;
    },
    localIsOpen(newVal) {
      this.$emit('update:isOpen', newVal);
      if (!newVal) {
        this.$emit('close');
      }
    }
  },

  methods: {
    handleConfirm() {
      this.localIsOpen = false;
      this.$emit('confirm');
    },
    handleCancel() {
      this.localIsOpen = false;
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.sensitive-content-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 32px 24px 28px;
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.2), 0 0 1px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: inherit;
}

.sensitive-content-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
}

.sensitive-content-title {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 12px;
  line-height: 1.25;
}

.sensitive-content-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
  margin: 0 0 24px;
  padding: 0 4px;
}

.sensitive-content-actions {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}

.sensitive-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  outline: none;
}

.sensitive-btn-confirm {
  background: linear-gradient(135deg, #715298 0%, #523568 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(113, 82, 152, 0.25);
}

.sensitive-btn-confirm:hover {
  opacity: 0.95;
  transform: translateY(-1px);
}

.sensitive-btn-confirm:active {
  transform: translateY(0);
}

.sensitive-btn-cancel {
  background: #e2e5e9;
  color: #4a5568;
}

.sensitive-btn-cancel:hover {
  background: #d8dce2;
  transform: translateY(-1px);
}

.sensitive-btn-cancel:active {
  transform: translateY(0);
}
</style>

<style>
.sensitive-content-dialog-container {
  border-radius: 20px !important;
  box-shadow: none !important;
  overflow: visible !important;
}
</style>
